import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userLogout } from "../../../actions";

class LoggedIn extends React.Component {
  handleUserLogout = (e) => {
    e.preventDefault();
    this.props.userLogout();
  };

  render() {
    return (
      <div className="upload__panel upload__panel--user upload__logged-in">
        <h3 className="upload__panel__header">
          Welcome back, {this.props.user.name}!
        </h3>

        <button
          className="button button--round"
          onClick={this.handleUserLogout}
        >
          Log out
        </button>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userLogout: userLogout.request,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(LoggedIn);
